import { approvalsTabUIInitialState } from "./uiLandingPageApprovalsTabState";
import { makeApprovalsTabUIActions } from "./uiLandingPageApprovalsTabActions";

export const createApprovalsTabUISlice = (set, get) => ({
  approvalsTabUI: approvalsTabUIInitialState,
  approvalsTabUIActions: Object.freeze(makeApprovalsTabUIActions(set, get)),
});
